import { i18nEn } from "./i18nEn";
import { i18nEs } from "./i18nEs";
import { i18nPl } from "./i18nPl";

export interface I18n {
  unsupportedBrowser: string;
  videoDeleted: string;
  videoInPreparation: string;

  sendReport: string;
  thankYouForSendingReport: string;
  configurationParsingFailure: string;
  resourceLoadingFailure: string;
  playbackFailure: string;
  runtimeError: string;

  subtitles: string;
  part: string;
  play: string;
  pause: string;
  replay: string;
  mute: string;
  unmute: string;
  fullscreen: string;
  share: string;
  exitFullscreen: string;
  poweredByVintom: string;
  licenceAdditionalText: string;
  licenceLabel: string;
  linkLicence: string;

  bandwidth: string;
  mbps: string;

  facebook: string;
  twitter: string;

  videoInPreparationLoadingPage: string;
}

export const i18n = {
  en: i18nEn,
  pl: i18nPl,
  es: i18nEs,
};
